/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { connect } from 'react-redux'
import { settingsMatchCount } from '../../actions/game'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import Filter2Icon from '@mui/icons-material/Filter2'
import Filter3Icon from '@mui/icons-material/Filter3'
import Filter4Icon from '@mui/icons-material/Filter4'
import { LEVELS, log } from '../../logs'

const counts = { 2: <Filter2Icon />, 3: <Filter3Icon />, 4: <Filter4Icon /> }

const MatchPicker = props => {
  log('MatchPicker', LEVELS.INFO, props)
  const { settings: { matchCount }, matchClick } = props
  return (
    <div className='settings-deck-picker'>
      <FormControl>
        <RadioGroup name='matchCount' value={matchCount} onChange={matchClick}>
          {
          Object.entries(counts).map(([count, icon]) =>
            <FormControlLabel key={count} value={count} control={<Radio />} label={icon} />)
        }
        </RadioGroup>
      </FormControl>
    </div>
  )
}

MatchPicker.displayName = 'MatchPicker'

const mapStateToProps = ({ settings }) => ({ settings })
const mapDispatchToProps = (dispatch) => ({
  matchClick: (matchCount) => { dispatch(settingsMatchCount(matchCount)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(MatchPicker)
